import React from 'react';

const ScenarioIcon = ({ type, className, style }) => {
  const commonProps = {
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    className,
    style,
  };

  switch (type) {
    case 'bulb':
      return (
        <svg {...commonProps}>
          <path d="M9 18h6" />
          <path d="M10 22h4" />
          <path d="M15 14c.2-1 .7-1.7 1.5-2.5A4.5 4.5 0 0 0 12 3a4.5 4.5 0 0 0-4.5 8.5c.8.8 1.3 1.5 1.5 2.5" />
        </svg>
      );
    case 'sun':
      return (
        <svg {...commonProps}>
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5L19 19M5 19l1.5-1.5M17.5 6.5L19 5" />
        </svg>
      );
    case 'wind':
      return (
        <svg {...commonProps}>
          <path d="M3 12h13a3 3 0 1 0-3-3" />
          <path d="M3 18h9a3 3 0 1 1-3 3" />
          <path d="M3 6h5a2 2 0 1 1-2-2" />
        </svg>
      );
    case 'thermo':
      return (
        <svg {...commonProps}>
          <path d="M14 14.76V3a2 2 0 0 0-4 0v11.76a4 4 0 1 0 4 0Z" />
        </svg>
      );
    case 'bolt':
      return (
        <svg {...commonProps}>
          <path d="M13 2L3 14h7l-1 8 10-12h-7z" />
        </svg>
      );
    case 'car':
      return (
        <svg {...commonProps}>
          <path d="M19 17h2V11a2 2 0 0 0-2-2h-1l-2-4H8L6 9H5a2 2 0 0 0-2 2v6h2" />
          <circle cx="7" cy="17" r="2" />
          <circle cx="17" cy="17" r="2" />
        </svg>
      );
    default:
      return null;
  }
};

export default ScenarioIcon;
